import React, { FC, useEffect } from 'react';
import './App.css';
import CustomRouter from './CustomRouter';
import history from './history';
import AppRoutes from './Routes';
import CreditScoreContext from './features/credit-report/component/credit-score-context';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import { APP_VERSION, SOURCE } from './data/constants';
import { manageSession } from './helpers/common-helper';

const App: FC = () => {
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);

    const queryToGet = [
      SOURCE.utm_source,
      SOURCE.utm_medium,
      SOURCE.utm_campaign,
      SOURCE.fk_seller_id,
      APP_VERSION,
    ];

    queryToGet.forEach((query) => {
      const queryParamValue = urlParams.get(query);
      if (queryParamValue) {
        sessionStorage.setItem(query, queryParamValue);
      }
    });
    manageSession();
  }, []);

  return (
    <CustomRouter history={history}>
      <CreditScoreContext>
        <AppRoutes />
      </CreditScoreContext>
    </CustomRouter>
  );
};

export default App;
